import compose from "lodash/flowRight"
import withPath from "../path/withPath"

const withLesson = (ComposedComponent) => (props) =>
  (
    <ComposedComponent
      {...props}
      lesson={props.items.find(
        (item) => item.source_id === props.lessonSourceId
      )}
    />
  )

withLesson.displayName = "withLesson"

export default compose(withPath, withLesson)
